import { ImageHelper, IMediaModel } from "@nf/common";
import ImageNext from "next/future/image";

import LinkWithLocale from "components/LinkWithLocale";
import { RouteHelper } from "helpers/routeHelper";

export type TItemPlaceholderSSR = {
  media?: IMediaModel;
};

import styles from "./ItemPlaceholderSSR.module.scss";

export const ItemPlaceholderSSR = ({ media }: TItemPlaceholderSSR) => {
  const detailsUrlObject = RouteHelper.goToDetails(media);
  const image = ImageHelper.getPosterImageUrl(media?.Images);
  const description = media?.Description || media?.ShortDescription;
  const category = media?.Categories?.[0]?.CategoryName;
  return (
    <div className={styles.container}>
      <LinkWithLocale href={detailsUrlObject.pathname ?? ""}>
        <a className={styles.text}>
          {media?.Title && <h2 className={styles.text}>{media?.Title}</h2>}
          {/* eslint-disable-next-line @next/next/no-img-element */}
          {image && typeof image === "string" && (
            <ImageNext
              src={image}
              alt={media?.Title || ""}
              quality={90}
              width={510}
              height={286}
              loading="lazy"
              priority={false}
            />
          )}
          {description && <p className={styles.text}>{description}</p>}
          {media?.Year && <p className={styles.text}>{media?.Year}</p>}
          {category && <p className={styles.text}>{category}</p>}
        </a>
      </LinkWithLocale>
    </div>
  );
};

export default ItemPlaceholderSSR;
